import _ from 'underscore';
import SingleZone from './SingleZone';
import Util from '../../util/Util';

const MultiZone = {

  zoneDetail(zone) {
    const {
      controlGroupId, headerId, categoryId, deliveryId,
    } = zone;
    const [firstRecommendation] = zone.recommendationVBList;
    const { recommendedItemId: productId } = firstRecommendation;
    const headerText = Util.header(zone.headerText);
    const encodedWithoutProductId = Util.encodedChoiceId({
      controlGroupId, deliveryId, headerId, headerText: zone.headerText, categoryId,
    });
    return {
      controlGroupId,
      headerId,
      categoryId,
      deliveryId,
      headerText,
      productId,
      encodedChoiceId: `${encodedWithoutProductId}$${productId}`,
      choiceId: `${controlGroupId.substring(3)}-${deliveryId}`,
      recommendedIdsList: zone.recommendationVBList.map(recommendation => ({
        id: recommendation.recommendedItemId,
        choiceId: `${encodedWithoutProductId}$${recommendation.recommendedItemId}`,
        clickTrackingUrl: Util.protocolLessUrl(recommendation.clickTrackingURL),
        productType: recommendation.productType || 'uncategorized',
      })),
    };
  },

  recommendation(config, json) {
    if (!config || !json) { return false; }
    const response = _.pick(json, 'status', 'error');

    response.content = json.content;
    response.recommendedItems = SingleZone.recommendation(json);
    if (response.recommendedItems) {
      let { zone } = config;
      const index = zone.indexOf('|');
      zone = (index === -1) ? zone : zone.substring(0, index);
      response.zone = zone;
      response.clickTrackingUrlPresent = response.recommendedItems.clickTrackingUrlPresent;
    } else {
      response.recommendationsOnAllZones = {};
      // looping over object, so es6 forEach will not work here.
      _.forEach(json.recommendationsOnAllZones, (zone, zoneKey) => {
        if (!zone) { return; }

        const detail = this.zoneDetail(zone, response);
        response.recommendationsOnAllZones[zoneKey] = detail;
        response.clickTrackingUrlPresent = detail.recommendedIdsList[0].clickTrackingUrl && true;
      });
    }

    return response;
  },
};


export default MultiZone;
